import React from 'react';
import { Link } from 'react-router-dom';
import '../Components/Footer.css';
import LOGO from "../images/NEWLOGO.png";

export default function Footer() {
  return (
    <footer className="vark-footer">
      <div className="footer-container">

        {/* Section 1: Brand Info & Star Rating */}
        <div className="footer-section brand-info">
          <Link to="/">
            <img src={LOGO} alt="VARK Builders Private Limited" className="footer-logo" />
          </Link>
          <p>
            VARK Builders Private Limited: Creating architectural landmarks with precision and passion.
            Recognized as the No. 1 construction company in Madurai & all over Tamil Nadu.
          </p>
          <div className="footer-rating-pill" style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            background: "rgba(255, 122, 0, 0.12)",
            border: "1px solid rgba(255, 122, 0, 0.35)",
            padding: "6px 12px",
            borderRadius: "6px",
            marginTop: "12px",
            fontSize: "0.85rem",
            color: "#ffb066"
          }}>
            <span style={{ color: "#f59e0b" }}>⭐⭐⭐⭐⭐</span>
            <strong>4.9/5.0</strong>
            <span style={{ color: "#aaa", fontSize: "0.78rem" }}>(485+ Reviews)</span>
          </div>
          <div className="social-icons">
            <a href="https://facebook.com/varkbuilders" target="_blank" rel="noreferrer" aria-label="Facebook"><i className="fab fa-facebook"></i></a>
            <a href="https://www.instagram.com/vark_builders_private_limited/" target="_blank" rel="noreferrer" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
            <a href="https://wa.me/919842943377" target="_blank" rel="noreferrer" aria-label="WhatsApp"><i className="fab fa-whatsapp"></i></a>
            <a href="https://www.linkedin.com/in/vm-samy-242011400/" target="_blank" rel="noreferrer" aria-label="LinkedIn"><i className="fab fa-linkedin"></i></a>
            <a href="https://www.youtube.com/@VarkBuilders" target="_blank" rel="noreferrer" aria-label="YouTube"><i className="fab fa-youtube"></i></a>
          </div>
        </div>

        {/* Section 2: Quick Links */}
        <div className="footer-section links">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/gallery">Project Gallery</Link></li>
            <li><Link to="/services">All Services</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        {/* Section 3: Services */}
        <div className="footer-section links">
          <h3>Our Services</h3>
          <ul>
            <li><Link to="/residential">Residential Construction</Link></li>
            <li><Link to="/commercial">Commercial Construction</Link></li>
            <li><Link to="/services">Home Repair & Renovation</Link></li>
            <li><Link to="/services">Turnkey House Construction</Link></li>
            <li><Link to="/services">Interior Works & Planning</Link></li>
          </ul>
        </div>

        {/* Section 4: Service Locations (High-Intent SEO Links) */}
        <div className="footer-section links">
          <h3>Service Locations</h3>
          <ul>
            <li><Link to="/#service-areas">📍 Madurai (HQ Hub)</Link></li>
            <li><Link to="/usilampatti">📍 Usilampatti Construction</Link></li>
            <li><Link to="/karaikudi">📍 Karaikudi Heritage Villas</Link></li>
            <li><Link to="/sivaganga">📍 Sivaganga Modern Homes</Link></li>
            <li><Link to="/thiruppuvanam">📍 Thiruppuvanam Residences</Link></li>
            <li><Link to="/theni">📍 Theni Luxury Villas</Link></li>
          </ul>
        </div>

        {/* Section 5: Contact Info */}
        <div className="footer-section contact">
          <h3>Contact Us</h3>
          <p><i className="fas fa-map-marker-alt"></i> 20, 1st Floor, Annai Teresa street, Bypass Rd, Fathima Nagar, Madurai - 625016</p>
          <p><i className="fas fa-phone"></i> +91 98429 43377</p>
          <p><i className="fas fa-envelope"></i> varkbuilders@gmail.com</p>
        </div>

      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} **VARK Builders Private Limited**. All Rights Reserved.</p>
        <p className="semms-credit">
          Built to inspire by <a href="https://semmssolutions.com/" target="_blank" rel="noopener noreferrer">SEMMS Solutions</a> – Elevating Your Digital Journey!
        </p>
      </div>
    </footer>
  );
}
